import { render, staticRenderFns } from "./CmgLargeOrderPromo.vue?vue&type=template&id=d256164e&scoped=true&lang=pug"
import script from "./cmg-large-order-promo.ts?vue&type=script&lang=ts&external"
export * from "./cmg-large-order-promo.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLargeOrderPromo.vue?vue&type=style&index=0&id=d256164e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d256164e",
  null
  
)

export default component.exports